import { blackColors, successColor, warningColor } from 'assets/jss/material-dashboard-pro-react';

const passwordRuleStyle = {
	passwordRules: {
		marginTop: '20px',
	},
};

export default passwordRuleStyle;
